<template>
  <div class="w-full flex flex-col">
    <ul class="flex flex-wrap">
      <li class="p-1" v-for="(step, index) of steps" :key="index">
        <div
            class="text-center p-2 border"
            :class="{
            'bg-primary-light text-onprimary-light border-onprimary-light': currentStep < index,
            'bg-primary text-onprimary border-primary': currentStep === index,
            'bg-success text-onsuccess border-success': currentStep > index,
          }"
        >
          <span>{{ step.label }}</span>
        </div>
      </li>
    </ul>
    <div class="px-1 mt-2">
      <div ref="wizard-body">
        <div :key="currentSlot">
          <slot :name="currentSlot"></slot>
        </div>
        <div class="w-full mt-5">
          <button class="btn float-left" v-if="canNavigateBack" @click.prevent="goBack()" type="button">
            <span>{{ previousStepLabel }}</span>
          </button>
          <button class="btn float-right" v-if="canNavigateNext" @click.prevent="goNext()" type="button">
            <span>{{ (currentStep == (steps.length - 1) ? finalStepLabel : nextStepLabel) }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Wizard',
  props: {
    steps: {},
    previousStepLabel: {default: 'Back'},
    nextStepLabel: {default: 'Next'},
    finalStepLabel: {default: 'Save'},
    canGoNext: {},
    canGoBack: {},
    onNavigatedTo: {},
    onNavigatedFrom: {},
  },
  watch: {
    steps: {
      handler() {
        this.parseOptions();
      },
      immediate: true,
    },
  },
  data() {
    return {
      currentStep: 0,
      isMounted: false,
      resizer: null,
      isMobile: false,
      options: [],
    };
  },
  computed: {
    currentSlot() {
      return this.steps[this.currentStep].slot;
    },
    canNavigateNext() {
      return (
          !this.options[this.currentStep].nextDisabled &&
          this.canNavigate(this.canGoNext)
      );
    },
    canNavigateBack() {
      return this.currentStep != 0 && this.canNavigate(this.canGoBack);
    },
  },
  methods: {
    canNavigate(method) {
      if (typeof method == 'function') {
        return method(this.currentStep);
      }
      return true;
    },
    goNext(skipFunction) {
      if (!skipFunction && !this.canNavigateNext) {
        //returned false. don't do anything
        return;
      }
      if (this.currentStep < this.steps.length - 1) {
        this.onNavigatedTo(++this.currentStep);
      }
    },
    goBack(skipFunction) {
      if (!skipFunction && !this.canNavigateBack) {
        //returned false. don't do anything
        return;
      }
      if (this.currentStep > 0) {
        this.onNavigatedFrom(this.currentStep);
        this.currentStep--;
      }
    },

    goTo(step) {
      if (Number.isInteger(step) && step < this.steps.length && step >= 0) {
        this.currentStep = step;
      }
    },

    parseOptions() {
      this.options = [];
      for (let i = 0; i < this.steps.length; i++) {
        this.options.push(this.steps[i].options ? this.steps[i].options : {});
      }
    },

    handleResize() {
      if (this.resizer) {
        clearTimeout(this.resizer);
      }
      this.resizer = setTimeout(() => {
        this.isMobile = this.$refs['wizard-body'].clientWidth < 620;
      }, 100);
    },
  },
  mounted() {
    this.isMobile = this.$refs['wizard-body'].clientWidth < 620;
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
